import { createAsyncThunk } from '@reduxjs/toolkit';
import { RedcatApiHandler } from 'polygon-utils';
import { PAYMENT_SESSION_STATUS } from '../../constants';

export const fetchPaymentSessionStatus = createAsyncThunk(
  '$fetchPaymentSessionStatus',
  async (reference: string, { rejectWithValue }) => {
    try {
      const response = await RedcatApiHandler.fetch({
        method: 'GET',
        path: `/api/v2/online-payments/sessions/${reference}/status`,
      });

      return {
        status: response?.data?.status as PAYMENT_SESSION_STATUS | null,
        reference: response?.data?.reference as string | null,
      };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
